import React, { useContext } from 'react';
import './../../../form.css'
import { Field } from 'formik'
import { TextField } from 'formik-material-ui';
import { Grid, Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import { InputFiles, FileList } from './../../../../common';
import { FieldError } from '../../../../common';
import { Switch } from '../../../../../components/common/formik';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const EthicsComplianceForm = (props) => {
    const classes = useStyles();

    const {        
        state
    } = useContext(CustomerRequestContext)

    const { 
        values,
        setFieldValue,
        isSavingRequest
    } = useContext(TabsContext);

    const fileUploadedHandler = (storedFile) => {
        const docs = [].concat(values.ethicsCompliance.mitigationAttachments || []);
        docs.push({ ...storedFile });

        //we need to set the value manually otherwise setFieldValue will not work property
        values.ethicsCompliance.mitigationAttachments = docs;
        setFieldValue("ethicsCompliance.mitigationAttachments", docs);
    }

    const fileRemovedHandler = (storedFile) => {
        const docs = values.ethicsCompliance.mitigationAttachments.filter(x => x.storedFileId !== storedFile.storedFileId);

        //we need to set the value manually otherwise setFieldValue will not work property
        values.ethicsCompliance.mitigationAttachments = docs;
        setFieldValue("ethicsCompliance.mitigationAttachments", docs);
    }

    return (
        <Card>
            <CardHeader title="Ethics and Compliance"/>
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            name="ethicsCompliance.areRedFlags"
                            label='Did you identify "red flags"?'
                            disabled={isSavingRequest || props.disabled}
                            onChange={event => {
                                event.persist();

                                if (!event.target.checked){
                                    setFieldValue("ethicsCompliance.isMitigated", false);
                                    setFieldValue("ethicsCompliance.mitigateActions", "");
                                    setFieldValue("ethicsCompliance.mitigationAttachments", []);
                                }
                            }}
                            component={Switch}
                        />
                        <FieldError name="ethicsCompliance.areRedFlags" errors={state.errors} />
                    </Grid>

                    {
                        values.ethicsCompliance.areRedFlags &&
                        <Grid item xl={12} md={12} xs={12}>
                            <Field
                                name="ethicsCompliance.isMitigated"
                                    label='Have mitigation measures been implemented or the "red flag" is not relevant?'
                                disabled={isSavingRequest || props.disabled}
                                onChange={event => {
                                    event.persist();
    
                                    if (!event.target.checked){
                                        setFieldValue("ethicsCompliance.mitigateActions", "");
                                        setFieldValue("ethicsCompliance.mitigationAttachments", []);
                                    }
                                }}
                                component={Switch}
                            />
                            <FieldError name="ethicsCompliance.isMitigated" errors={state.errors} />
                        </Grid>
                    }

                    {
                        values.ethicsCompliance.isMitigated &&
                        <>
                            <Grid item xl={12} md={12} xs={12}>
                                <Field
                                    multiline
                                    variant="outlined"
                                    name="ethicsCompliance.mitigateActions"
                                    label="Explain the actions/mitigation measure *"
                                    disabled={isSavingRequest || props.disabled}
                                    component={TextField}
                                    className={classes.field}
                                /> 
                                <FieldError name="ethicsCompliance.mitigateActions" errors={state.errors} />  
                            </Grid>

                            <Grid item xl={12} md={12} xs={12}>
                                <FileList 
                                    title="Mitigation attachments"
                                    files={values.riskEvaluation ? values.ethicsCompliance.mitigationAttachments : []}
                                    disabled={isSavingRequest || props.disabled}
                                    onFileRemoved={fileRemovedHandler}
                                />
                                <FieldError name="ethicsCompliance.mitigationAttachments" errors={state.errors} />
                            </Grid>

                            {
                                !props.disabled &&
                                <Grid item xl={12} md={12} xs={12}>
                                    <InputFiles 
                                        title="Upload attachments"
                                        onFileUploaded={fileUploadedHandler}
                                    />
                                </Grid>
                            }
                        </>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}